<template>
  <article
      class="mvt-cardproperty"
      :class="theme"
      :data-loading="loading"
      :data-link-name="glb.pageType === 'vmapsearch' && property.isActive && property.threeDTourLink ? '3D Card' : 'Card'"
      :data-id="property.propertyId"
      :mark-id="'mark0_' + property.geo.lat + '_' + property.geo.lng"
      :data-provider="property.showProvidedBy && property.mlsName ? `${molang('search.card.providedBy')} ${property.mlsName}` : null"
  >
    <propertyCardSchema :data="property" v-if="showSchema" />
    <PropertyCardImage
        :property="property"
        :showStreetView="showStreetView"
        :staticMapData="staticMapData"
        :previewPhoto="previewPhoto"
        :class="theme"
        :cardParent="cardParent"
        @openDpp="onCardClick"
    />
    <PropertyCardInfo :property="property" :cardHref="cardHref" :splitAddress="theme === 'style3'" @openDpp="onCardClick"/>
    <PropertyCardTags
        :property="property"
        :selectedCard="selectedCard"
        :showLeadButton="showLeadButton"
        :cardFilter="cardFilter"
        :theme="theme"
        @openDpp="onCardClick"
    />
  </article>
</template>
<script src="./mvt-cardproperty.js"></script>

<style lang="scss">
@use "./mvt-cardproperty.scss" as *;
</style>
